export default {
  data() {
    return {
      statusItems: [
        "OPEN",
        "NO DOCKET",
        "COMPLETED",
        "REQUESTED DOCKET",
        "NON-CLAIMABLE DOCKET",
        "CREDIT REQUESTED",
        "CREDIT RECEIVED",
        "CREDIT TO BE REQUESTED"
      ],
    }
  }
}